import { Mail, Phone, Globe, FileDown } from "lucide-react";
import { SERIES } from "../data/content";

export const Footer = () => (
    <footer data-testid="site-footer" className="relative overflow-hidden border-t border-white/10 bg-[#04060d]">
        <div className="pointer-events-none absolute inset-x-0 bottom-0 select-none overflow-hidden">
            <p className="translate-y-[28%] whitespace-nowrap text-center font-display text-[18vw] leading-none text-white/[0.035]">
                DEADLY AMBITION
            </p>
        </div>

        <div className="relative mx-auto max-w-[1500px] px-5 sm:px-8 pt-20 pb-40">
            <div className="grid gap-12 md:grid-cols-3">
                <div>
                    <div className="leading-none">
                        <p className="font-display text-xl tracking-[0.18em] text-white">DEADLY AMBITION</p>
                        <p className="mt-2 font-mono text-[9px] tracking-[0.3em] text-zinc-500">THE OSIRICA SAGA</p>
                    </div>
                    <p className="mt-6 max-w-xs text-sm leading-relaxed text-zinc-500">
                        A Celestial Light Studios original television series. Pilot complete — Season One fully
                        scripted.
                    </p>
                </div>

                <div>
                    <p className="font-mono text-[10px] tracking-[0.3em] text-[#d6c68e]">CONTACT</p>
                    <div className="mt-5 space-y-3">
                        <a data-testid="footer-email-link" href={`mailto:${SERIES.email}`} className="flex items-center gap-3 text-sm text-zinc-300 transition-colors hover:text-[#d6c68e]">
                            <Mail size={14} className="text-zinc-600" /> {SERIES.email}
                        </a>
                        <a data-testid="footer-phone-link" href={`tel:${SERIES.phone.replace(/\s/g, "")}`} className="flex items-center gap-3 text-sm text-zinc-300 transition-colors hover:text-[#d6c68e]">
                            <Phone size={14} className="text-zinc-600" /> {SERIES.phone}
                        </a>
                        <a data-testid="footer-website-link" href={SERIES.website} target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 text-sm text-zinc-300 transition-colors hover:text-[#d6c68e]">
                            <Globe size={14} className="text-zinc-600" /> www.celestialstudio.org
                        </a>
                        <a data-testid="footer-sell-sheet-link" href="/sell-sheet/" target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 text-sm text-zinc-300 transition-colors hover:text-[#d6c68e]">
                            <FileDown size={14} className="text-zinc-600" /> One-page sell sheet (PDF)
                        </a>
                    </div>
                </div>

                <div>
                    <p className="font-mono text-[10px] tracking-[0.3em] text-[#d6c68e]">CONFIDENTIALITY</p>
                    <p className="mt-5 max-w-xs text-[13px] leading-relaxed text-zinc-500">
                        This presentation and all materials are confidential, prepared for acquisitions executives,
                        sales agents and streaming platform evaluation. Do not distribute without written consent from
                        Celestial Light Studios.
                    </p>
                </div>
            </div>

            <div className="mt-16 flex flex-col gap-3 border-t border-white/10 pt-6 sm:flex-row sm:items-center sm:justify-between">
                <p className="font-mono text-[10px] tracking-[0.25em] text-zinc-600">
                    © 2026 CELESTIAL LIGHT STUDIOS · AUSTRALIA
                </p>
                <p className="font-mono text-[10px] tracking-[0.25em] text-zinc-600">
                    DEADLY AMBITION — AN ORIGINAL SERIES PRESENTATION
                </p>
            </div>
        </div>
    </footer>
);
